<script setup lang="ts">
import { useGlobalStateStore } from '@/store/globalState'

/**
 * 浏览器限制，如果在浏览器中打开，将会显示此页面
 */

interface Emits {
  (e: 'playSound'): void
}

const emit = defineEmits<Emits>()

const globalStore = useGlobalStateStore()

function playSound() {
  emit('playSound')
  globalStore.setCanAutoplayMedia(true)
}
</script>

<template>
  <div class="absolute h-full w-full top-0 left-0 bg-[rgba(0,0,0,0.8)] z-9999 px-8">
    <div class="flex flex-col items-center justify-center h-full w-full gap-2">
      <p class="text-6 text-white text-center">
        Welcome to Sekai, where your fanfiction comes to life.
      </p>
      <div class="mt-4">
        <button
          class="btn-primary" @click="() => {
            playSound()
          }"
        >
          Let me in!
        </button>
      </div>
    </div>
  </div>
</template>
